import { useEffect, useState } from "react";
import { Check, Loader2, Sparkles } from "lucide-react";
import type { DemoFormData } from "../demoTypes";

const STEPS = [
  "İşletme bilgileri hazırlanıyor",
  "Hizmetleriniz yerleştiriliyor",
  "Görselleriniz hazırlanıyor",
  "Müşteri iletişim akışınız oluşturuluyor",
  "Demo hazır",
];

export default function DemoProcessing({
  data,
  onDone,
}: {
  data: DemoFormData;
  onDone: () => void;
}) {
  const [active, setActive] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    const timers: number[] = [];
    STEPS.forEach((_, i) => {
      timers.push(window.setTimeout(() => setActive(i + 1), i * 750 + 300));
    });
    timers.push(window.setTimeout(() => setFinished(true), STEPS.length * 750 + 500));
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, []);

  useEffect(() => {
    if (!finished) return;
    const t = window.setTimeout(onDone, 600);
    return () => window.clearTimeout(t);
  }, [finished, onDone]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background-100 px-4 py-12">
      <div className="animate-fade-in-up w-full max-w-lg rounded-2xl border border-background-200 bg-background-50 p-7 md:p-9">
        <div className="flex items-center gap-3">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
            <Sparkles className="h-5 w-5" strokeWidth={2.2} />
          </span>
          <div>
            <h1 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">
              Harika, bilgilerinizi aldık.
            </h1>
            <p className="text-sm text-foreground-500">{data.firmaAdi || "İşletmeniz"} için demo hazırlanıyor…</p>
          </div>
        </div>

        <div className="mt-7 space-y-4">
          {STEPS.map((label, i) => {
            const isDone = active > i;
            const isCurrent = active === i;
            return (
              <div key={label} className="flex items-center gap-3">
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition ${
                    isDone
                      ? "bg-accent-500 text-primary-950"
                      : isCurrent
                        ? "bg-primary-100 text-primary-600"
                        : "bg-background-200 text-foreground-400"
                  }`}
                >
                  {isDone ? (
                    <Check className="h-4 w-4" strokeWidth={2.5} />
                  ) : isCurrent ? (
                    <Loader2 className="h-4 w-4 animate-spin" />
                  ) : (
                    <span className="h-2 w-2 rounded-full bg-foreground-300" />
                  )}
                </span>
                <span
                  className={`text-sm font-medium transition ${
                    isDone
                      ? "text-foreground-700"
                      : isCurrent
                        ? "text-foreground-900"
                        : "text-foreground-400"
                  }`}
                >
                  {label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}